<template>
  <div class="productPrice">
    <div class="personalization">
      <div class="personalization-cen">
        <h1>方案灵活 适配企业<span style="color: #2B77FF;">个性化</span></h1>
        <p>应用灵活适配企业个性化、高扩展需求，实惠的价格打造最贴心的服务</p>
      </div>
    </div>
    
    
    <div class="customization">
      <div class="customization-cen">
        <h1>定制化服务，助力企业快速降本增效</h1>
        <p>随着全球化竞争越来越激烈，中小型企业亟待企业转型以应对市场的变化</p>
        <img src="../assets/price/2.png" alt="">
      </div>
    </div>

    
    <!-- <div class="costRequirements" v-if="false">
      <div class="costRequirements-cen">
        <h1>实在的价格，满足企业不同的成本需求</h1>
        <p>助您全面了解理业产品价格，为您预估使用成本提供帮助，选择真正适合您的产品方案</p>
        <div class="table-container">
            <div class="table-row">
                <div class="table-cell first-column">产品管理系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">30000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
            <div class="table-row">
                <div class="table-cell first-column">销售管理系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">40000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
            <div class="table-row">
                <div class="table-cell first-column">供应管理系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">40000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
            <div class="table-row">
                <div class="table-cell first-column">仓储管理系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">20000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
            <div class="table-row">
                <div class="table-cell first-column">生产管理系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">30000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
            <div class="table-row">
                <div class="table-cell first-column">品质管理系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">20000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
            <div class="table-row">
                <div class="table-cell first-column">设备管理系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">20000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
            <div class="table-row">
                <div class="table-cell first-column">设备管理系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">30000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
            <div class="table-row">
                <div class="table-cell first-column">财务管理系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">20000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
            <div class="table-row">
                <div class="table-cell first-column">设备物联网系统</div>
                <div class="table-cell second-column"><a @click="openPopUp()">10000起</a></div>
                <div class="table-cell third-column">套</div>
            </div>
        </div>
      </div>
    </div> -->


    
    
    <div class="giveService">
      <div class="giveService-cen">
        <h1>全程无忧，提供贴心的企业专属服务</h1>
        <p>随着全球化竞争越来越激烈，中小型企业亟待企业转型以应对市场的变化</p>
        <div class="giveService-btn clearfloat">
            <div @click="showContent(0)" :class="{ 'giveService-active': currentIndex === 0 }">基础服务</div>
            <div @click="showContent(1)" :class="{ 'giveService-active': currentIndex === 1 }">定制服务</div>
        </div>
        <div class="giveService-content">
            <div>
                <img src="../assets/price/3.png" alt="" v-if="currentIndex == 0">
                <img src="../assets/price/4.png" alt="" v-if="currentIndex == 1">
                <button @click="openPopUp()">立即咨询</button>
            </div>
        </div>
      </div>  
    </div>
    
    
    <pop-up :display="showPopUp" @update:display="updateDisplay"></pop-up>



  </div>
</template>

<script>
import popUp from '@/components/popUp.vue'
export default {
  components:{popUp},

  name: 'productPrice',
  data () {
    return {
        currentIndex: 0,
        showPopUp: false,
    }
  },
  methods: {
    showContent(index) {
        this.currentIndex = index;
    },
    openPopUp() {
        this.showPopUp = true
    },
    updateDisplay(newValue) {
        this.showPopUp = newValue;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.productPrice {
  background: #fff;
}
.personalization {
  background: url(../assets/price/1.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  height: 522px
}
.personalization-cen,.customization-cen,.costRequirements-cen,.giveService-cen {
  width: 1460px;
  margin: 0 auto;
}
.personalization-cen {
  padding-top: 148px;
}
.personalization-cen h1 {
  font-weight: bold;
  font-size: 70px;
  color: #3F3F3F;
  font-style: normal;
  margin-bottom: 16px;
}
.personalization-cen p {
  font-weight: 400;
  font-size: 18px;
  color: #3F3F3F;
}


.customization {

}
.customization-cen {
  padding-top: 72px;
  padding-bottom: 70px;
  text-align: center;
}
.customization-cen > h1 {
  font-weight: bold;
  font-size: 36px;
  color: #3F3F3F;
  margin-bottom: 4px;
}
.customization-cen > p {
  font-weight: 400;
  font-size: 14px;
  color: #3F3F3F;
  margin-bottom: 74px;
}


.costRequirements {

}
.costRequirements-cen {
  text-align: center;
}
.costRequirements-cen > h1 {
  font-weight: bold;
  font-size: 36px;
  color: #3F3F3F;
  margin-bottom: 4px;
}
.costRequirements-cen > p {
  font-weight: 400;
  font-size: 14px;
  color: #3F3F3F;
  margin-bottom: 74px;
}
.table-container {
    display: table;
    width: 100%;
    border-collapse: collapse;
}
.table-row {
    display: table-row;
}
.table-row a{
  cursor: pointer;
}
.table-cell {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    height: 93px; /* 行高 */
    font-size: 24px;
}
.first-column {
    width: 312px;
    background: #F5F8FF;
    border-radius: 8px 0px 0px 8px;
    color: #3F3F3F;
    /* 没有边框 */
}
.second-column, .third-column {
    width: 567px;
    background: #FFFFFF;
    border: 1px solid #DAE6FF;
    box-sizing: border-box;
}
.second-column a {
    text-decoration: none;
    color: #2B77FF;
}



.giveService {

}
.giveService-cen {
  padding-top: 72px;
  padding-bottom: 70px;
  text-align: center;
}
.giveService-cen > h1 {
  font-weight: bold;
  font-size: 36px;
  color: #3F3F3F;
  margin-bottom: 4px;
}
.giveService-cen > p {
  font-weight: 400;
  font-size: 14px;
  color: #3F3F3F;
  margin-bottom: 74px;
}
.giveService-btn {
    width: 544px;
    margin: 0 auto;
    cursor: pointer;
}
.giveService-btn div{
    width: 272px;
    line-height: 80px;
    float: left;
    font-weight: 500;
    font-size: 20px;
    color: #3F3F3F;
}
.giveService-active {
    background: #F7F9FF;
}
.giveService-content div {
    height: 766px;
    background: #F5F8FF;
    border-radius: 8px;
    padding-top: 60px;
    box-sizing: border-box;
    position: relative;
}
.giveService-content div button {
    width: 200px;
    height: 40px;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    background: #2B77FF;
    display: block;
    margin-left: -100px;
    position: absolute;
    bottom: 40px;
    left: 50%
}
</style>


// WEBPACK FOOTER //
// src/components/productPrice.vue